import { render, staticRenderFns } from "./MoveDeAssemblyWorkRadioField.vue?vue&type=template&id=3a0eb436"
import script from "./MoveDeAssemblyWorkRadioField.vue?vue&type=script&lang=js"
export * from "./MoveDeAssemblyWorkRadioField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports